import React, { useEffect, useState } from "react";
import axios from "axios";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Floating WhatsApp Admin button.
 * Opens wa.me with the admin's number pulled from /api/public/whatsapp-admin.
 * If admin hasn't set a number, shows a toast "Belum ada nomor tersedia".
 */
export default function WhatsAppFab({ position = "left", context = "" }) {
  const [wa, setWa] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/whatsapp-admin`).then((r) => setWa(r.data)).catch(() => setWa({ number: "", label: "Admin Wedifylab" }));
  }, []);

  const click = (e) => {
    e.preventDefault();
    if (!wa || !wa.number) { toast.info("Belum ada nomor tersedia"); return; }
    const msg = context ? `Halo ${wa.label || "Admin Wedifylab"}, saya ingin bertanya seputar ${context}.` : `Halo ${wa.label || "Admin Wedifylab"}, saya perlu bantuan.`;
    const url = `https://wa.me/${wa.number}?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank");
  };

  const posClass = position === "left"
    ? "bottom-5 left-5"
    : "bottom-5 right-5";

  return (
    <button
      type="button"
      data-testid="whatsapp-admin-fab"
      onClick={click}
      aria-label="Hubungi Admin via WhatsApp"
      title="Hubungi Admin via WhatsApp"
      className={`fixed z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-green-900/30 transition-transform hover:-translate-y-1 active:scale-95 ${posClass}`}
    >
      <MessageCircle className="h-6 w-6" />
      <span className="absolute -right-1 -top-1 flex h-3 w-3">
        <span className="absolute inset-0 animate-ping rounded-full bg-green-400 opacity-75" />
        <span className="relative inline-flex h-3 w-3 rounded-full bg-green-500" />
      </span>
    </button>
  );
}
